"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityEmbed = exports.EntityEmbedImageStyles = exports.EntityEmbedDefaultProps = exports.EntityEmbedNameSizes = exports.EntityEmbedImageHeights = exports.EntityEmbedImageWidthsDesktopLarge = exports.EntityEmbedImageWidthsDesktop = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cell_label_1 = require("../elements/cell-label");
var entity_title_1 = require("./entity-title");
var banner_controls_1 = require("../elements/banner-controls");
var entity_image_link_1 = require("./entity-image-link");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_icons_1 = require("../../hooks/use-icons");
var icon_1 = require("../elements/icon");
var router_1 = require("@reach/router");
var content_1 = require("../elements/content");
var lodash_1 = require("lodash");
exports.EntityEmbedImageWidthsDesktop = {
  small: 1184 / 10,
  embed: 1184 / 6,
  medium: 1184 / 6,
  large: 1184 / 4,
  veryLarge: 1184 / 2
};
exports.EntityEmbedImageWidthsDesktopLarge = {
  small: 1184 / 10,
  embed: 1184 / 4,
  medium: 1184 / 4,
  large: 1184 / 2.5,
  veryLarge: 1184 / 2
};
exports.EntityEmbedImageHeights = {
  small: 68,
  embed: 140,
  medium: 116,
  large: 220,
  veryLarge: 328
};
exports.EntityEmbedNameSizes = {
  small: 'tiny',
  embed: 'medium',
  medium: 'medium',
  large: 'large',
  veryLarge: 'veryLarge'
};
exports.EntityEmbedDefaultProps = {
  size: 'medium',
  controls: [],
  blended: false,
  alignItems: 'flex-start',
  useImageViewer: false
};
// -------- Styles --------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    cursor: pointer;\n    background: ", ";\n\n    ", "\n\n    &:hover {\n      outline: 1px solid ", ";\n    }\n \n    h4.shp-cell-label {\n      font-weight: 400 !important;\n      font-size: ", ";\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    cursor: pointer;\n    background: ", ";\n\n    ", "\n\n    &:hover {\n      outline: 1px solid ", ";\n    }\n \n    h4.shp-cell-label {\n      font-weight: 400 !important;\n      font-size: ", ";\n    }\n  "])), theme_1.theme.COLOR('app-chrome'), function (_a) {
    var blended = _a.blended;
    return blended && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), theme_1.theme.COLOR('app-chrome'));
  }, theme_1.theme.COLOR('primary-very-light'), theme_1.theme.FONT_SIZE(13)),
  desktop: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
exports.EntityEmbedImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n    align-self: stretch;\n    height: 142px;\n  "], ["\n    width: 100%;\n    align-self: stretch;\n    height: 142px;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    height: 182px;\n  "], ["\n    height: 182px;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    height: auto;\n    ", "\n\n    ", "\n  "], ["\n    height: auto;\n    ", "\n\n    ", "\n  "])), function (_a) {
    var size = _a.size;
    return (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      height: ", "px;\n      width: ", "px;\n    "], ["\n      height: ", "px;\n      width: ", "px;\n    "])), exports.EntityEmbedImageHeights[size], exports.EntityEmbedImageWidthsDesktop[size]);
  }, function (_a) {
    var alignImage = _a.alignImage;
    return alignImage === 'end' && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      order: 2;\n    "], ["\n      order: 2;\n    "])));
  }),
  desktopLarge: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    height: auto;\n    ", "\n  "], ["\n    height: auto;\n    ", "\n  "])), function (_a) {
    var size = _a.size;
    return (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      height: ", "px;\n      width: ", "px;\n    "], ["\n      height: ", "px;\n      width: ", "px;\n    "])), exports.EntityEmbedImageHeights[size], exports.EntityEmbedImageWidthsDesktopLarge[size]);
  })
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: ", " 0 ", " 0;\n    width: 100%;\n    box-sizing: border-box;\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: ", " 0 ", " 0;\n    width: 100%;\n    box-sizing: border-box;\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), function (_a) {
    var useDivider = _a.useDivider;
    return useDivider && (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme_1.theme.V_DOT_BG());
  }, function (_a) {
    var alignItems = _a.alignItems;
    return (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      align-items: ", ";\n    "], ["\n      align-items: ", ";\n    "])), alignItems);
  }, function (_a) {
    var size = _a.size;
    return size === 'small' && (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      padding: ", " ", " ", " ", ";\n    "], ["\n      padding: ", " ", " ", " ", ";\n    "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), theme_1.theme.UNIT(5));
  }),
  tablet: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding: ", " ", " ", " ", ";\n    flex-direction: row;\n\n    ", "\n\n  "], ["\n    padding: ", " ", " ", " ", ";\n    flex-direction: row;\n\n    ", "\n\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), function (_a) {
    var size = _a.size;
    return size === 'small' && (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      padding: ", " ", " ", " ", ";\n    "], ["\n      padding: ", " ", " ", " ", ";\n    "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4));
  })
});
var InfoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n  "])))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    margin: 0 0 ", " 0; \n  "], ["\n    margin: 0 0 ", " 0; \n  "])), theme_1.theme.UNIT(2))
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    margin: 0 0 ", " 0;\n    padding-bottom: 0 !important;\n\n    ", "\n  "], ["\n    margin: 0 0 ", " 0;\n    padding-bottom: 0 !important;\n\n    ", "\n  "])), theme_1.theme.UNIT(2), function (_a) {
    var hasChildren = _a.hasChildren;
    return !hasChildren && (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n      margin-bottom: 0;\n    "], ["\n      margin-bottom: 0;\n    "])));
  })
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ConnectionsLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    cursor: pointer;\n    ", ";\n\n    &:hover {\n      ", ";\n    }\n  "], ["\n    cursor: pointer;\n    ", ";\n\n    &:hover {\n      ", ";\n    }\n  "])), theme_1.theme.FILL('dark'), theme_1.theme.FILL('primary'))
});
var ConversationLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    cursor: pointer;\n    ", ";\n\n    &:hover {\n      ", ";\n    }\n  "], ["\n    cursor: pointer;\n    ", ";\n\n    &:hover {\n      ", ";\n    }\n  "])), theme_1.theme.FILL('dark'), theme_1.theme.FILL('primary'))
});
var TitleAndLinksStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    justify-content: space-between;\n  "])))
});
var LinksStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    align-items: flex-start;\n    align-self: flex-start;\n    \n  "], ["\n    align-items: flex-start;\n    align-self: flex-start;\n    \n  "])))
});
var NameAndDescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    max-width: 1000px;\n  "], ["\n    max-width: 1000px;\n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    margin-top: ", ";\n\n    ", "\n  "], ["\n    margin-top: ", ";\n\n    ", "\n  "])), theme_1.theme.UNIT(2), function (_a) {
    var _size = _a._size;
    return _size === 'embed' && (0, styled_components_1.css)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n      div {\n      }\n    "], ["\n      div {\n      }\n    "])));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.span(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: (0, styled_components_1.default)(entity_image_link_1.EntityImageLink)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), exports.EntityEmbedImageStyles),
  Body: styled_components_1.default.div(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  TitleAndLinks: styled_components_1.default.div(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), TitleAndLinksStyles),
  Title: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Links: (0, styled_components_1.default)(banner_controls_1.BannerControls)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), LinksStyles),
  Header: styled_components_1.default.header(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Info: styled_components_1.default.div(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  NameAndDescription: styled_components_1.default.div(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), NameAndDescriptionStyles),
  Name: (0, styled_components_1.default)(entity_title_1.EntityTitle)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Description: (0, styled_components_1.default)(content_1.Content)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  ConnectionsLink: (0, styled_components_1.default)(icon_1.Icon)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), ConnectionsLinkStyles),
  ConversationLink: (0, styled_components_1.default)(icon_1.Icon)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), ConversationLinkStyles)
};
var EntityEmbed = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity,
    title = props.title,
    blended = props.blended,
    size = props.size;
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity, true);
  if (!definition) {
    return null;
  }
  var banner = definition.banner;
  var alignItems = props.alignItems;
  var useDivider = props.useDivider;
  var components = definition.components;
  var Icons = (0, use_icons_1.useIcons)();
  var onClick = function () {
    (0, router_1.navigate)(definition.to(entity.slug));
  };
  var onConnectionsClick = function () {
    (0, router_1.navigate)(definition.to(entity.slug, 'connections'));
  };
  var onConversationClick = function () {
    (0, router_1.navigate)(definition.to(entity.slug, 'conversation'));
  };
  var controls = [definition.useConversation && react_1.default.createElement(My.ConversationLink, {
    size: 18,
    onClick: onConversationClick
  }, react_1.default.createElement(Icons.Entities.Comment, null)), definition.useConnections && react_1.default.createElement(My.ConnectionsLink, {
    size: 18,
    onClick: onConnectionsClick
  }, react_1.default.createElement(Icons.AppSections.Platform, null))];
  // todo - make this better!
  var imageSize = definition.name === 'Person' ? 'large' : size;
  var openGraph = entity.openGraph;
  var description = openGraph && openGraph.description && (openGraph.description.plainTruncated || openGraph.description.plain || openGraph.description.text);
  return react_1.default.createElement(My.Container, {
    onClick: onClick,
    blended: blended,
    className: className
  }, components.image ? react_1.default.createElement(components.image, {
    blended: blended,
    isEmbed: true,
    size: imageSize,
    entity: entity
  }) : react_1.default.createElement(My.Image, {
    alignImage: banner.alignImage || 'start',
    size: imageSize,
    entity: entity
  }), react_1.default.createElement(My.Body, {
    useDivider: useDivider,
    alignItems: alignItems,
    blended: blended,
    size: size
  }, react_1.default.createElement(My.Info, null, react_1.default.createElement(My.TitleAndLinks, null, react_1.default.createElement(My.Title, null, props.title || definition.label), react_1.default.createElement(My.Links, {
    showFirstBorder: false,
    items: controls
  })), react_1.default.createElement(My.NameAndDescription, null, react_1.default.createElement(My.Name, {
    size: exports.EntityEmbedNameSizes[size],
    entity: entity,
    hasChildren: !!children
  }), (0, lodash_1.includes)(['medium', 'large', 'embed'], size) && description && react_1.default.createElement(My.Description, {
    _size: size,
    tiny: true,
    html: description
  }), children))));
};
exports.EntityEmbed = EntityEmbed;
exports.EntityEmbed.defaultProps = exports.EntityEmbedDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41;